import { useReduxState } from "../../explorer/redux/hooks";
import { reduxStoreConfig } from "../configuration/reduxStoreConfig";

export const useAppError: () => [string, (error: string) => void] = () => {
  const [error, setError] = useReduxState<string>(reduxStoreConfig.systemError);
  return [error, setError];
};
